var _path, _path2, _rect, _rect2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle, _circle2, _rect1, _rect10, _rect11, _rect12, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWastedSpendMetricNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.668 228.968H170.668V259.468H149.668L187.168 299.468L223.668 259.468H203.668V228.968Z",
    fill: "#528FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.668 228.968H160.668V259.468H139.668L177.168 299.468L213.668 259.468H193.668V228.968Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98.168,
    y: 132.968,
    width: 153,
    height: 17,
    fill: "#192657"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 215.168,
    y: 168.968,
    width: 25,
    height: 25,
    fill: "#F58120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.143 86.6183C179.743 86.3849 180.943 85.8433 181.743 84.9933C182.543 84.1266 182.943 82.9766 182.943 81.5433C182.943 80.9766 182.843 80.4849 182.643 80.0683C182.443 79.6349 182.168 79.2516 181.818 78.9183C181.468 78.5849 181.051 78.2933 180.568 78.0433C180.085 77.7766 179.56 77.5433 178.993 77.3433L178.143 86.6183ZM176.218 61.1183C175.368 61.2349 174.643 61.4266 174.043 61.6933C173.443 61.9433 172.951 62.2516 172.568 62.6183C172.201 62.9849 171.926 63.3933 171.743 63.8433C171.576 64.2766 171.493 64.7433 171.493 65.2433C171.493 65.8099 171.585 66.3183 171.768 66.7683C171.968 67.2016 172.243 67.5933 172.593 67.9433C172.943 68.2933 173.36 68.6099 173.843 68.8933C174.326 69.1599 174.86 69.4016 175.443 69.6183L176.218 61.1183ZM179.568 70.9683C180.368 71.2016 181.168 71.4599 181.968 71.7433C182.768 72.0099 183.535 72.3183 184.268 72.6683C185.001 73.0183 185.685 73.4266 186.318 73.8933C186.951 74.3599 187.501 74.9099 187.968 75.5433C188.451 76.1599 188.826 76.8766 189.093 77.6933C189.36 78.5099 189.493 79.4433 189.493 80.4933C189.493 82.0433 189.226 83.5099 188.693 84.8933C188.176 86.2599 187.41 87.4766 186.393 88.5433C185.376 89.5933 184.135 90.4516 182.668 91.1183C181.201 91.7849 179.518 92.1849 177.618 92.3183L177.318 95.7183C177.285 96.1516 177.101 96.5433 176.768 96.8933C176.435 97.2433 176.001 97.4183 175.468 97.4183H172.943L173.418 92.1433C172.468 92.0099 171.526 91.8099 170.593 91.5433C169.676 91.2599 168.793 90.9266 167.943 90.5433C167.093 90.1433 166.293 89.7016 165.543 89.2183C164.793 88.7183 164.118 88.1766 163.518 87.5933L165.643 84.4683C165.826 84.2016 166.076 83.9849 166.393 83.8183C166.71 83.6349 167.035 83.5433 167.368 83.5433C167.751 83.5433 168.151 83.6599 168.568 83.8933C168.985 84.1266 169.443 84.4099 169.943 84.7433C170.46 85.0599 171.035 85.3849 171.668 85.7183C172.318 86.0516 173.068 86.3099 173.918 86.4933L174.868 76.1183C174.068 75.9016 173.268 75.6599 172.468 75.3933C171.685 75.1099 170.926 74.7849 170.193 74.4183C169.46 74.0516 168.776 73.6266 168.143 73.1433C167.526 72.6433 166.985 72.0516 166.518 71.3683C166.051 70.6849 165.685 69.9016 165.418 69.0183C165.151 68.1183 165.018 67.0849 165.018 65.9183C165.018 64.6183 165.276 63.3599 165.793 62.1433C166.31 60.9099 167.06 59.8099 168.043 58.8433C169.043 57.8766 170.268 57.0849 171.718 56.4683C173.168 55.8349 174.835 55.4683 176.718 55.3683L176.993 52.3933C177.026 51.9599 177.21 51.5766 177.543 51.2433C177.893 50.8933 178.326 50.7183 178.843 50.7183H181.393L180.943 55.6183C182.743 55.9349 184.285 56.4516 185.568 57.1683C186.851 57.8849 187.951 58.6933 188.868 59.5933L187.168 62.0933C186.935 62.4766 186.685 62.7599 186.418 62.9433C186.151 63.1099 185.835 63.1933 185.468 63.1933C185.218 63.1933 184.918 63.1266 184.568 62.9933C184.235 62.8433 183.86 62.6683 183.443 62.4683C183.026 62.2516 182.56 62.0349 182.043 61.8183C181.543 61.6016 181.01 61.4183 180.443 61.2683L179.568 70.9683Z",
    fill: "#F58120"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.168,
    y: 99.9683,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.168,
    y: 119.968,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68.168,
    y: 139.968,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68.168,
    y: 159.968,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 267.168,
    y: 132.773,
    width: 18.5,
    height: 2.89062,
    rx: 1.44531,
    fill: "#192657"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 277.863,
    y: 124.968,
    width: 18.5,
    height: 2.89062,
    rx: 1.44531,
    transform: "rotate(90 277.863 124.968)",
    fill: "#192657"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 218.168,
    y: 222.968,
    width: 72,
    height: 4,
    fill: "#F58120"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 251.168,
    y: 232.968,
    width: 39,
    height: 4,
    fill: "#F58120"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.668,
    cy: 210.468,
    r: 9.5,
    fill: "#F58120"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.668,
    cy: 95.4683,
    r: 13.5,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 97.168,
    y: 110.968,
    width: 153,
    height: 96,
    rx: 7,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 110.168,
    y: 181.968,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "#528FF5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 140.168,
    y: 181.968,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "#528FF5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 170.168,
    y: 181.968,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "#528FF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.67 128.468C251.336 66.8014 177.47 -26.7319 92.6697 92.4681C-13.3303 241.468 160.17 375.468 212.17 297.968C264.17 220.468 260.668 201.468 241.168 191.468",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWastedSpendMetricNew);
export default __webpack_public_path__ + "static/media/WastedSpendMetricNew.b0426bc696b57075a3f7e73154a1d73a.svg";
export { ForwardRef as ReactComponent };